const CalendarMinusIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.6673 14.9997V11.6663C25.6673 10.1936 24.4734 8.99967 23.0007 8.99967H9.00065C7.52789 8.99967 6.33398 10.1936 6.33398 11.6663V22.9997C6.33398 24.4724 7.52789 25.6663 9.00065 25.6663H15.0007M25.6673 22.6663H19.6673M10.6673 6.33301V10.9997M21.334 6.33301V10.9997M10.334 14.333H21.6673"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default CalendarMinusIcon
